// src/services/paymentSettingsService.js
import { DEFAULT_PAYMENT_CONFIG, PAYMENT_PROVIDERS, PAYMENT_METHODS } from '../config/payments.js';

function PaymentSettingsService() {
    this.restaurantSettings = new Map();
    this.authFetchFunction = null;
}

// ПРОСТО ДОБАВИТЬ ЭТУ ПЕРЕМЕННУЮ


// ПРОСТО ДОБАВИТЬ ЭТУ ФУНКЦИЮ
PaymentSettingsService.prototype.setAuthFetch = function(fn) {
    this.authFetchFunction = fn;
}

PaymentSettingsService.prototype.loadRestaurantPaymentSettings = function(restaurantId, amount = null, forceRefresh = false) {
    var self = this;

    return new Promise(function(resolve, reject) {
        if (!restaurantId) {
            console.warn('No restaurant ID provided');
            resolve(DEFAULT_PAYMENT_CONFIG);
            return;
        }

        if (forceRefresh !== true && self.restaurantSettings.has(restaurantId)) {
            resolve(self.restaurantSettings.get(restaurantId));
            return;
        }

        var url = '/telegram/client/api/payment/settings?restaurantId=' + restaurantId;
        if (amount) {
            url += '&amount=' + amount;
        }

        var fetchFn = self.authFetchFunction || fetch;

        // authFetch из useAuthFetch возвращает уже распарсенный JSON (не Response-объект)
        // и сам бросает исключение при HTTP-ошибках
        fetchFn(url)
            .then(function(result) {
                if (!result.success) {
                    throw new Error(result.error || 'Failed to load payment settings');
                }

                var transformedSettings = self.transformBackendResponse(result.data, restaurantId);
                self.restaurantSettings.set(restaurantId, transformedSettings);
                resolve(transformedSettings);
            })
            .catch(function(error) {
                console.error('Error loading payment settings:', error);

                var defaultSettings = Object.assign({}, DEFAULT_PAYMENT_CONFIG, {
                    restaurantId: restaurantId,
                    isActive: false,
                    error: error.message
                });

                self.restaurantSettings.set(restaurantId, defaultSettings);
                resolve(defaultSettings);
            });
    });
};

/**
 * Трансформирует ответ бэкенда в формат, понятный фронтенду
 */
PaymentSettingsService.prototype.transformBackendResponse = function(backendData, restaurantId) {
    // Проверяем наличие провайдеров
    if (!backendData.providers || backendData.providers.length === 0) {
        return Object.assign({}, DEFAULT_PAYMENT_CONFIG, {
            restaurantId: restaurantId,
            isActive: false
        });
    }

    // Берем провайдера по умолчанию или первого
    var defaultProvider = backendData.defaultProvider || backendData.providers[0];

    // Находим метод по умолчанию или первый
    var defaultMethod = defaultProvider.methods.find(function(m) { return m.is_default; }) ||
        defaultProvider.methods[0];

    // Формируем настройки
    var settings = {
        provider: defaultProvider.provider,
        methods: defaultProvider.methods.map(function(m) { return m.method; }),
        testMode: defaultProvider.test_mode || false, // Берем из провайдера
        currencies: ['RUB'],
        isActive: backendData.isActive || defaultProvider.is_active, // Используем isActive из ответа
        restaurantId: restaurantId,

        // Сохраняем полные данные для детальной работы
        fullData: backendData,

        // Специфичные для провайдера настройки
        credentials: defaultMethod.credentials || {},
        options: {
            skin: 'modern',
            language: 'ru-RU'
        }
    };

    return settings;
};

// Остальные методы без изменений
PaymentSettingsService.prototype.validateAndMergeSettings = function(settings, restaurantId) {
    if (!settings || typeof settings !== 'object') {
        return Object.assign({}, DEFAULT_PAYMENT_CONFIG, {
            restaurantId: restaurantId,
            isActive: false,
            error: 'Invalid settings format'
        });
    }

    var provider = this.validateProvider(settings.provider);
    var methods = this.validateMethods(settings.methods);
    var credentials = this.validateCredentials(settings.credentials, provider);
    var options = this.validateOptions(settings.options, provider);

    return {
        provider: provider,
        methods: methods,
        testMode: Boolean(settings.testMode),
        currencies: Array.isArray(settings.currencies) ? settings.currencies : DEFAULT_PAYMENT_CONFIG.currencies,
        credentials: credentials,
        options: options,
        isActive: Boolean(settings.isActive !== false),
        restaurantId: restaurantId,
        originalSettings: settings,
        fullData: settings.fullData
    };
};

PaymentSettingsService.prototype.validateProvider = function(provider) {
    if (provider && Object.values(PAYMENT_PROVIDERS).includes(provider)) {
        return provider;
    }
    return DEFAULT_PAYMENT_CONFIG.provider;
};

PaymentSettingsService.prototype.validateMethods = function(methods) {
    if (!Array.isArray(methods) || methods.length === 0) {
        return DEFAULT_PAYMENT_CONFIG.methods;
    }

    var validMethods = Object.values(PAYMENT_METHODS);
    return methods.filter(function(method) {
        return validMethods.includes(method);
    });
};

PaymentSettingsService.prototype.validateCredentials = function(credentials, provider) {
    if (!credentials || typeof credentials !== 'object') {
        return null;
    }

    if (provider === PAYMENT_PROVIDERS.CLOUD_PAYMENTS) {
        return {
            publicKey: String(credentials.publicKey || ''),
            apiSecret: String(credentials.apiSecret || '')
        };
    }

    return credentials;
};

PaymentSettingsService.prototype.validateOptions = function(options, provider) {
    var baseOptions = {
        language: 'ru-RU',
        skin: 'modern',
        autoFocus: true,
        showPayButton: true
    };

    if (!options || typeof options !== 'object') {
        return baseOptions;
    }

    var result = {};
    for (var key in baseOptions) {
        if (baseOptions.hasOwnProperty(key)) {
            result[key] = baseOptions[key];
        }
    }
    for (var key2 in options) {
        if (options.hasOwnProperty(key2)) {
            result[key2] = options[key2];
        }
    }

    return result;
};

PaymentSettingsService.prototype.getActiveProvider = function(settings) {
    return settings && settings.provider ? settings.provider : DEFAULT_PAYMENT_CONFIG.provider;
};

PaymentSettingsService.prototype.getAvailableMethods = function(settings) {
    return settings && settings.methods ? settings.methods : DEFAULT_PAYMENT_CONFIG.methods;
};

PaymentSettingsService.prototype.isMethodAvailable = function(settings, method) {
    if (!settings) return false;
    var methods = this.getAvailableMethods(settings);
    return methods.includes(method);
};

PaymentSettingsService.prototype.isPaymentActive = function(settings) {
    return settings && settings.isActive !== false;
};

PaymentSettingsService.prototype.getFullPaymentData = function(restaurantId) {
    var settings = this.restaurantSettings.get(restaurantId);
    return settings ? settings.fullData : null;
};

PaymentSettingsService.prototype.clearCache = function(restaurantId) {
    if (restaurantId) {
        this.restaurantSettings.delete(restaurantId);
    } else {
        this.restaurantSettings.clear();
    }
};

PaymentSettingsService.prototype.clearAllCache = function() {
    this.restaurantSettings.clear();
};

var paymentSettingsService = new PaymentSettingsService();

export { PaymentSettingsService, paymentSettingsService };